module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_niconico_m.b02c9a8f8881d1bce489eb4ba8b3a5cd.png";